import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AccountLocation } from '../models/account-location';

@Injectable({
  providedIn: 'root'
})
export class LocationStateService {
  private readonly selectedLocationSubject = new BehaviorSubject<AccountLocation | null>(null);
  private readonly allLocationsSubject = new BehaviorSubject<AccountLocation[]>([]);

  get selectedLocation$(): Observable<AccountLocation | null> {
    return this.selectedLocationSubject.asObservable();
  }

  get allLocations$(): Observable<AccountLocation[]> {
    return this.allLocationsSubject.asObservable();
  }

  setAllLocations(locations: AccountLocation[]): void {
    const safeLocations = locations ?? [];
    const current = this.selectedLocationSubject.value;
    const match = current ? safeLocations.find((l) => l.id === current.id) : null;
    this.allLocationsSubject.next(safeLocations);
    this.selectedLocationSubject.next(match ?? safeLocations[0] ?? null);
  }

  setSelectedLocation(location: AccountLocation | null): void {
    this.selectedLocationSubject.next(location);
  }
}
